<div class="container">
    <div class="row">
        <div class="col-md-12">
            <p *ngIf="url_param == '400'" class="error_code">400</p>
            <p *ngIf="url_param == '404'" class="error_code">404</p>
        </div>
    </div>
</div>